import { FaGraduationCap, FaBook, FaRupeeSign, FaUsers, FaMicrophone, FaIndustry } from 'react-icons/fa';

function AchievementsSection({ buyLink, onBuyClick }) {
  const achievements = [
    {
      icon: <FaGraduationCap className="text-4xl sm:text-5xl text-amber-400" />,
      number: "25+",
      label: "Years Experience",
      sublabel: "in Payment Recovery"
    },
     {
      icon: <FaRupeeSign className="text-4xl sm:text-5xl text-amber-400" />,
      number: "₹42Cr+",
      label: "Amount Recovered",
      sublabel: "Till Date"
    },
     {
      icon: <FaUsers className="text-4xl sm:text-5xl text-amber-400" />,
      number: "18000+",
      label: "Total Students",
      sublabel: "in Community"
    },
      {
      icon: <FaMicrophone className="text-4xl sm:text-5xl text-amber-400" />,
      number: "104+",
      label: "Seminars & Webinars",
      sublabel: "Conducted"
    },
    
    {
      icon: <FaIndustry className="text-4xl sm:text-5xl text-amber-400" />,
      number: "120+",
      label: "Industries Served",
      sublabel: "Till Date"
    },
    {

      icon: <FaBook className="text-4xl sm:text-5xl text-amber-400" />,
      number: "Author",
      label: '"23-Principles to Get Your Payments on Time Always',
      sublabel: ' The definitive guide to mastering payment collection'
    },
   
   
  
  ];

  return (
    <section className="relative py-24 px-4 sm:px-8 bg-slate-900 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        {/* CTA Button */}
        <div className="text-center mb-14">
          <button 
            onClick={onBuyClick}
            className="inline-block bg-gradient-to-r from-amber-400 via-amber-500 to-orange-500 text-slate-900 px-12 sm:px-20 py-4 sm:py-5 rounded-xl text-lg sm:text-2xl font-extrabold shadow-[0_10px_20px_-5px_rgba(251,191,36,0.4)] hover:shadow-[0_20px_30px_-8px_rgba(251,191,36,0.5)] hover:-translate-y-0.5 transition-all duration-200 tracking-wide cursor-pointer"
          >
            Book a call →
          </button>
        </div>

        {/* Title */}
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-black text-white text-center mb-4 drop-shadow-lg">
          Achievements 
        </h1>
        <p className="text-lg sm:text-xl lg:text-2xl text-slate-400 text-center mb-12 max-w-3xl mx-auto font-medium">
          Proven expertise backed by decades of real-world success in payment recovery
        </p>

        {/* Achievements Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {achievements.map((achievement, index) => (
            <div 
              key={index}
              className="group relative bg-gradient-to-br from-slate-800 to-slate-900 rounded-2xl p-6 sm:p-8 lg:p-10 text-center border border-amber-500/20 hover:border-amber-500/40 transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_20px_25px_-5px_rgba(0,0,0,0.4),0_8px_10px_-6px_rgba(0,0,0,0.4)] overflow-hidden"
            >
              {/* Top Border Gradient */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-400 to-orange-500"></div>
              
              {/* Icon */}
              <div className="w-16 h-16 sm:w-20 sm:h-20 lg:w-24 lg:h-24 mx-auto mb-4 sm:mb-6 rounded-2xl bg-amber-500/15 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform duration-300">
                {achievement.icon}
              </div>

              {/* Number */}
              <div className="text-4xl sm:text-5xl lg:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500 mb-2 leading-none tracking-tight">
                {achievement.number}
              </div>

              {/* Label */}
              <div className="text-lg sm:text-xl lg:text-[22px] text-white font-bold mb-1 leading-tight">
                {achievement.label}
              </div>
              <div className="text-base sm:text-lg text-slate-400 font-medium">
                {achievement.sublabel}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default AchievementsSection;
